import { configureStore } from "@reduxjs/toolkit";
import navReducer from "../redux/navReducer";
import notificationReducer from "../redux/notificationReducer";
import gymReducer from "./gymReducer";
import scheduleReducer from "./scheduleReducer";

const store = configureStore({
  reducer: {
    navbar: navReducer,
    notification: notificationReducer,
    gym: gymReducer,
    schedule: scheduleReducer,
  },
});

export const dispatch = store.dispatch;
export default store;
